import DefaultButton from "./DefaultButton";

export default function DoubleImageText({ 
    title, 
    description, 
    image1, 
    alt1,
    image2, 
    alt2,
    image1Description, 
    image2Description 
}) {
    return (
        <section className="min-h-screen md:h-screen flex flex-col md:flex-row gap-16 md:gap-0 py-16 md:py-0">
            <div className="flex flex-col justify-center px-6 md:px-14 gap-10 md:w-1/2">
                <h2 className="lg:text-5xl text-4xl text-mcare font-semibold md:drop-shadow-lg text-balance panoragraf-light">
                    {title}
                </h2>

                {description}
                <DefaultButton text="Prenota una visita" link="#contatti" buttonClass="lg:w-full xl:w-1/2" />
            </div>

            <div className="relative flex items-center px-6 md:px-14 md:w-1/2">
                <div className=" w-full">
                    <div className="w-full md:w-1/2 md:ml-auto md:absolute md:left-0 md:top-20">
                        <img src={image1} alt={alt1} className="w-full rounded-md object-cover shadow-lg" />
                        <p className="text-white text-sm text-center mt-3 px-10">{image1Description}</p>
                    </div>

                    <div className="w-full md:w-1/2 mt-8 md:mt-0 md:absolute md:right-8 md:bottom-36">
                        <img src={image2} alt={alt2} className="w-full rounded-md object-cover shadow-lg" />
                        <p className="text-white text-sm text-center mt-3 px-10">{image2Description}</p>
                    </div>
                </div>
            </div>
        </section>
    );
}